import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetLearnerAllDrivingClassesDataA, GetLearnerClassInitiatedOTPA } from "../Actions/UserA";
  
export function useLearnerOTPWatcher(UserId, UserType) {
  const dispatch = useDispatch();
  const { LearnerClassInitiatedOTP, LearnerAllDrivingClassesData } =
    useSelector((s) => s.LoginSignupReducer);

  const [showPopup, setShowPopup] = useState(false);

  // Save next class time
  useEffect(() => {
    if (!LearnerAllDrivingClassesData?.classes?.length) return;

    const now = new Date();
    const upcoming = LearnerAllDrivingClassesData.classes
      .filter(c => new Date(c.startDate) > now)
      .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

    if (!upcoming.length) {
      localStorage.removeItem("NextOTPDrivingClassTime");
      return;
    }

    localStorage.setItem(
      "NextOTPDrivingClassTime",
      new Date(upcoming[0].startDate).toISOString()
    );
  }, [LearnerAllDrivingClassesData]);

  // Fetch classes once
  useEffect(() => {
    if (UserId && UserType === "Student") {
      dispatch(GetLearnerAllDrivingClassesDataA(UserId));
    }
  }, [UserId, UserType]);

  // OTP polling
  useEffect(() => {
    if (!UserId || UserType !== "Student") return;

    const interval = setInterval(() => {
      const time = localStorage.getItem("NextOTPDrivingClassTime");
      if (!time) return;

      const diff = (new Date() - new Date(time)) / 60000;
      if (diff >= 0 && diff <= 10 && !LearnerClassInitiatedOTP?.ClassOTP) {
        dispatch(GetLearnerClassInitiatedOTPA(UserId));
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [UserId, UserType, LearnerClassInitiatedOTP]);

  useEffect(() => {
    if (LearnerClassInitiatedOTP?.ClassOTP) {
      setShowPopup(true);
    }
  }, [LearnerClassInitiatedOTP]);

  return {
    showPopup,
    otp: LearnerClassInitiatedOTP?.ClassOTP,
    closePopup: () => setShowPopup(false),
  };
}
